module.exports = __webpack_public_path__ + "static/media/olesya.fddd5116.png";